<template>
  <code-list title="Produkty" module-name="product"></code-list>
</template>

<script>
  import codeList from 'components/productCodeList';

  export default {
    components: {codeList}
  }
</script>



// WEBPACK FOOTER //
// client/views/products.vue